import jQuery from 'jquery';
import 'bootstrap';
import VMasker from 'vanilla-masker';

import 'fonts/index';

window.$ = jQuery;
window.jQuery = jQuery;
window.VMasker = VMasker;